import styles from './CompactCommentButton.module.css'

type CompactCommentButtonProps = {
  onClick: () => void
  id?: string
  children: React.ReactNode
  ref?: React.Ref<HTMLButtonElement>
}

export const CompactCommentButton = ({ref, onClick, id, children}: CompactCommentButtonProps) => (
  <button type="button" id={id} ref={ref} onClick={onClick} className={styles.CompactCommentInputContainer}>
    {children}
  </button>
)

CompactCommentButton.displayName = 'CompactCommentButton'
